import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Cancel} from '@material-ui/icons';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';

class BasicInput extends Component {
    state = {
        emptyValidation: true,
        focus: false,
        firstAssignValue: true,
        legalEmail: true,
        legalPhone: true,
    };

    componentWillReceiveProps(nextProps) {
        if (this.input) {
            if (
                this.state.firstAssignValue &&
                util.isString(nextProps.defalutValue)
            ) {
                this.input.value = nextProps.defalutValue;
                this.props.inputValid(this.props.title, nextProps.defalutValue);

                this.setState({
                    firstAssignValue: false,
                });
            } else if (
                nextProps.value !== this.input.value &&
                util.isString(nextProps.value)
            ) {
                this.input.value = nextProps.value;
            }
        }
    }

    clearInput = () => {
        this.input.value = '';

        if (
            typeof this.props.checkEmail !== 'undefined' &&
            this.props.checkEmail
        ) {
            this.setState({
                emptyValidation: false,
            });
        } else if (
            typeof this.props.checkShipToPhone !== 'undefined' &&
            this.props.checkShipToPhone
        ) {
            this.setState({
                emptyValidation: false,
            });
        }
        this.props.inputValid(this.props.title, '');
    };

    foucusInput = (title) => (event) => {
        let empty = true;
        let isPhone = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        this.setState({
            focus: true,
        });
        if (
            typeof this.props.checkShipToPhone !== 'undefined' &&
            this.props.checkShipToPhone
        ) {
            if (event.target.value && event.target.value.length > 0) {
                const regex = /^((86|\+86|\+86 |86 )\d{11})$/;
                const isValid = regex.test(event.target.value);

                const regex2 = /^(?:\d{2,4}(?:-|\s)?\d{7,8})$/;
                const isValidTel = regex2.test(event.target.value);
                if (!isValidTel && !isValid) {
                    isPhone = false;
                } else {
                    isPhone = true;
                }
            }

            this.props.inputValid(title, event.target.value);
            this.setState({
                emptyValidation: empty,
                legalPhone: isPhone,
            });
        } else {
            this.setState({
                emptyValidation: empty,
            });
            this.props.inputValid(title, event.target.value);
        }

        if (util.isFunction(this.props.blurFoucus)) {
            this.props.blurFoucus();
        }
    };

    blurAction = () => {
        setTimeout(() => {
            this.setState({
                focus: false,
            });
            if (util.isFunction(this.props.blurAction)) {
                this.props.blurAction();
            }
        }, 200);

        if (this.props.onBlur) {
            this.props.onBlur();
        }
    };

    inputValid = (title) => (event) => {
        let empty = true;
        let isNotEmail = true;
        let isPhone = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        if (
            typeof this.props.checkEmail !== 'undefined' &&
            this.props.checkEmail
        ) {
            if (event.target.value && event.target.value.length > 0) {
                const strReg =
                    /^\w+((-\w+)|(\.\w+))*\@{1}\w+\.{1}\w{2,4}(\.{0,1}\w{2}){0,1}/gi;
                const isRegFlag = event.target.value.search(strReg);
                if (isRegFlag === -1) {
                    isNotEmail = false;
                }
            }

            this.setState({
                emptyValidation: empty,
                legalEmail: isNotEmail,
            });
            this.props.inputValid(title, event.target.value, isNotEmail);
        } else if (
            typeof this.props.checkShipToPhone !== 'undefined' &&
            this.props.checkShipToPhone
        ) {
            if (event.target.value && event.target.value.length > 0) {
                const regex = /^((86|\+86|\+86 |86 )\d{11})$/;
                const isValid = regex.test(event.target.value);

                const regex2 = /^(?:\d{2,4}(?:-|\s)?\d{7,8})$/;
                const isValidTel = regex2.test(event.target.value);
                if (!isValidTel && !isValid) {
                    isPhone = false;
                } else {
                    isPhone = true;
                }
            }

            this.props.inputValid(title, event.target.value);
            this.setState({
                emptyValidation: empty,
                legalPhone: isPhone,
            });
        } else {
            this.setState({
                emptyValidation: empty,
            });
            this.props.inputValid(title, event.target.value);
        }
    };

    render() {
        const {
            title,
            placeholder,
            type,
            disabled,
            defaultValue,
            value,
            smallBasicInput,
            checkEmail,
            required,
            testid,
        } = this.props;
        const {emptyValidation, focus, legalEmail, legalPhone} = this.state;

        return (
            <div className="basic-input-container">
                <div
                    className={
                        emptyValidation
                            ? typeof checkEmail !== 'undefined'
                                ? 'basic-input eamil-basic-input'
                                : 'basic-input'
                            : 'basic-input empty'
                    }>
                    {!util.getPropertyExistsAndIsTrue(smallBasicInput) ? (
                        <label className="input-title">
                            {required ? (
                                <span className="form-required">*</span>
                            ) : null}
                            {T(title)}
                        </label>
                    ) : null}
                    <input
                        className={
                            util.getPropertyExistsAndIsTrue(smallBasicInput)
                                ? 'input-content small-input-content'
                                : 'input-content'
                        }
                        onChange={this.inputValid(title)}
                        placeholder={
                            emptyValidation
                                ? T(placeholder)
                                : T('input_required')
                        }
                        type={type || 'text'}
                        defaultValue={defaultValue || ''}
                        value={value || null}
                        ref={(input) => (this.input = input)}
                        onBlur={this.blurAction}
                        onFocus={this.foucusInput(title)}
                        disabled={disabled}
                        testid={testid ? testid : ''}
                    />
                    {this.input && this.input.value && focus ? (
                        <Cancel
                            className={
                                util.getPropertyExistsAndIsTrue(smallBasicInput)
                                    ? 'cancel-button small-cancel-button'
                                    : 'cancel-button'
                            }
                            onClick={this.clearInput}
                        />
                    ) : null}
                </div>

                {emptyValidation && !legalEmail ? (
                    <div className="illegal-message">{T('errorEmail')}</div>
                ) : null}
                {emptyValidation && !legalPhone ? (
                    <div className="illegal-message">
                        {T(this.props.warningInfo)}
                    </div>
                ) : null}
            </div>
        );
    }
}

BasicInput.propTypes = {
    title: PropTypes.string.isRequired,
};

export default BasicInput;
